import { projectRequest } from 'store/utils/request';

export default ({
  selectedIntent,
  newIntent,
}: {
  selectedIntent: string;
  newIntent: string;
}) =>
  projectRequest.post(`/intents/${selectedIntent}/replace_usages/`, {
    new_intent: newIntent,
  });
